<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import Card from '@/Components/LiveEvent/Card.vue'

const props = defineProps({
  liveEvent: {
    type: Object,
    required: true,
  },
  cols: {
    type: Number,
  },
})

const emit = defineEmits(['remove'])

const removeLiveEvent = () => {
  emit('remove', props.liveEvent.id)
}
</script>

<template>
  <div class="relative">
    <div class="absolute -top-4 z-30 -right-2">
      <button
        @click.prevent="removeLiveEvent"
        type="button"
        class="h-8 w-8 p-1.5 bg-white hover:bg-gray-200 rounded-lg border border-gray-100"
      >
        <XMarkIcon class="text-red-400" />
      </button>
    </div>
    <div class="absolute w-full h-full bg-white bg-opacity-25 flex items-center justify-center">
      <div class="bg-black py-1 px-4 rounded-full bg-opacity-50 text-white text-xs">{{ __('Preview Only') }}</div>
    </div>
    <div class="w-full mx-auto">
      <Card
        :live-event
        :cols
      />
    </div>
  </div>
</template>

